import { toast } from 'react-toastify';

const toastSuccess = (message: string, options?: object): void => {
  toast.success(message, {
    position: 'top-center',
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    ...options,
  });
};

export default toastSuccess;
